export class Team {
    public id: string;
    public name: string;
    public partnerCount: number;
    public loggedInUserEmail: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/teams/team.model.ts